import React from "react"
import { Stack, Text, LinkOverlay } from "@chakra-ui/react"

import Link from "@components/Link"
import { Description, FoldedPage } from "./Styles"
import TextButton from "@components/TextButton"

const PageItem = ({ title, description, link }: NormalisedPage) => (
  <FoldedPage as="article">
    <LinkOverlay as={Link} to={link.url}>
      <Text size="lg" mb={0.5} fontWeight="semibold">
        {title}
      </Text>
      <Stack spacing={1} alignItems="flex-start">
        <Description>{description}</Description>
        <TextButton size="lg" icon="chevronRight" textTransform="none">
          {/* TODO: Add to locales */}
          View page
        </TextButton>
      </Stack>
    </LinkOverlay>
  </FoldedPage>
)

export default PageItem
